import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

export const fallbackLocale = 'sk';

export const SUPPORT_LOCALES = ['en', 'sk', 'cs'];

export async function setLanguage(paramsLocale: string) {
  await Promise.all([loadLocaleMessages(i18n, fallbackLocale), loadLocaleMessages(i18n, paramsLocale)]);

  setI18nLanguage(i18n, paramsLocale);
}

export const i18n = createI18n({
  locale: 'sk',
  fallbackLocale: fallbackLocale,
  warnHtmlMessage: false,
  warnHtmlInMessage: 'off',
});

export function setupI18n(options = { locale: 'sk', fallbackLocale: fallbackLocale, warnHtmlMessage: false }) {
  const i18n = createI18n(options);
  setI18nLanguage(i18n, options.locale);
  return i18n;
}

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  const el = document.querySelector('html');
  if (el) {
    el.setAttribute('lang', locale);
  }
}

export async function loadLocaleMessages(i18n, locale) {
  // load locale messages with dynamic import
  const messages = await import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`);

  //console.log(replaceJsonString(JSON.parse(JSON.stringify(messages))));
  
  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages.default);        

  return nextTick();
}

/*function replaceJsonString(obj) {
  Object.keys(obj).forEach(function(key) {
  		if(typeof obj[key] === "string") {
      	obj[key] = "zzzzzzzzzzzzzzzzz";
      }
      else {
      	replaceJsonString(obj[key])
      }
  })
  return obj;
}*/